export default {
    requestStarting(state) {
        state.requestsInProgress++
        if (state.progressBar) {
            state.progressBar.start()
        }
    },
    requestCompleted(state) {
        state.requestsInProgress--
        if (state.progressBar) {
            state.progressBar.finish()
        }
    },
    requestFailed(state) {
        state.requestsInProgress--
        if (state.progressBar) {
            state.progressBar.fail()
        }
    },
    setProgressBar(state, progressBar) {
        state.progressBar = progressBar
    },
    setUser(state, payload) {
        state.user = Object.freeze(payload || {})
        state.initialising = false
    },
    setEvents(state, payload) {
        state.events = Object.freeze(payload || {})
    },
    setNextEvent(state, payload) {
        state.nextEvent = payload
    },
    setCurrentEvent(state, payload) {
        state.currentEvent = payload
    },
    setTeams(state, payload) {
        state.teams = Object.freeze(payload || {})
    },
    isInitialising(state, payload) {
        state.initialising = payload
    },
    setLoggingOut(state, payload) {
        state.isLoggingOut = payload
    },
    setUserNotifications(state, data) {
        state.notifications = data
    },
    showBanner(state, banner) {
        state.banner = banner
    },
    hideBanner(state) {
        if (state.banner !== null) {
            state.banner.show = false
        }
        state.banner = null
    },
    showSnackbar(state, value) {
        // as the text is the key, and to prevent duplicates, check if we're
        // showing another message with the same text
        if (state.snackbars.some(x => x.text === value.text)) {
            return
        }

        value.show = true
        value.timeout = value.type == 'error' ? 4000 : 1500
        state.snackbars.push(value)

        // ugly workaround to remove an autohidden snackbar when max timeout expires
        setTimeout(() => {
            this.commit('hideSnackbar', value)
        }, value.timeout)
    },
    hideSnackbar(state, value) {
        value.show = false
        state.snackbars = state.snackbars.filter(x => x.show)
    },
    setAppVersion(state, value) {
        state.version = value
    },
    setManagingGroups(state, value) {
        state.managingGroups = Object.freeze(value)
    },
}
